import {
  Button,
  SelectProps,
  Table,
  TableHead,
  TableCell,
  TableRow,
  Select,
  InputLabel,
  MenuItem,
  Typography,
} from '@mui/material';
import DefaultLayout from 'layouts/default';
import './index.css';

import MUIDataTable, {
  MUIDataTableOptions,
  MUIDataTableProps,
} from 'mui-datatables';

const ManiSkill2021ResultsPage = () => {
  const data0: MUIDataTableProps['data'] = [
    [
      1,
      'Silver-Bullet-3D',
      <a target="_blank" href="https://github.com/caiqi/Silver-Bullet-3D">
        Github
      </a>,
      0.574,
      0.716,
      0.896,
      0.932,
      0.468,
      0.488,
      0.208,
      0.556,
      0.328,
    ],
    [
      2,
      'Fattonny',
      <a target="_blank" href="https://github.com/Zed-Wu/ManiSkill-Learn">
        Github
      </a>,
      0.407,
      0.32,
      0.764,
      0.84,
      0.4,
      0.336,
      0.16,
      0.184,
      0.252,
    ],
    [
      3,
      'bigfish',
      <a target="_blank" href="https://github.com/liu666666/bigfish_codes">
        Github
      </a>,
      0.3435,
      0.36,
      0.664,
      0.74,
      0.256,
      0.26,
      0.124,
      0.192,
      0.152,
    ],
    [
      4,
      'MI',
      <a target="_blank" href="https://github.com/1800012973/ManiSkill">
        Github
      </a>,
      0.332,
      0.268,
      0.7,
      0.788,
      0.32,
      0.156,
      0.124,
      0.12,
      0.18,
    ],
    [
      5,
      'SieRra11799',
      '',
      0.1895,
      0.196,
      0.2,
      0.456,
      0.212,
      0.144,
      0.044,
      0.144,
      0.12,
    ],
    [
      6,
      'ic',
      <a
        target="_blank"
        href="https://github.com/art-e-fact/ManiSkill-Learn/tree/submission-Cabinet"
      >
        Github
      </a>,
      0.188,
      0.108,
      0.28,
      0.484,
      0.156,
      0.06,
      0.072,
      0.228,
      0.116,
    ],
    [
      7,
      'Zhihao',
      '',
      0.1835,
      0.176,
      0.272,
      0.416,
      0.216,
      0.104,
      0.068,
      0.12,
      0.096,
    ],
  ];

  const data1: MUIDataTableProps['data'] = [
    [
      1,
      'EPIC Lab',
      <a target="_blank" href="https://github.com/wkwan7/EPICLab-ManiSkill">
        Github
      </a>,
      0.743,
      0.748,
      0.94,
      0.94,
      0.484,
      0.752,
      0.696,
      0.924,
      0.46,
    ],
    [
      2,
      'Silver-Bullet-3D',
      <a target="_blank" href="https://github.com/caiqi/Silver-Bullet-3D">
        Github
      </a>,
      0.5595,
      0.66,
      0.888,
      0.928,
      0.464,
      0.436,
      0.232,
      0.52,
      0.348,
    ],
    [
      3,
      'MI',
      <a target="_blank" href="https://github.com/1800012973/ManiSkill">
        Github
      </a>,
      0.151,
      0,
      0,
      0.856,
      0,
      0,
      0,
      0.352,
      0,
    ],
  ];

  const data2: MUIDataTableProps['data'] = [
    [
      1,
      'Silver-Bullet-3D',
      <a target="_blank" href="https://github.com/caiqi/Silver-Bullet-3D">
        Github
      </a>,
      0.928,
      0.964,
      0.96,
      0.988,
      0.884,
      0.944,
      0.744,
      1,
      0.94,
    ],
    [
      2,
      'aidan-curtis',
      <a target="_blank" href="https://github.com/aidan-curtis/az-manipulator">
        Github
      </a>,
      0.6895,
      0.772,
      0.472,
      0.972,
      0.732,
      0.572,
      0.28,
      0.988,
      0.728,
    ],
    [
      3,
      'Fattonny',
      <a target="_blank" href="https://github.com/Zed-Wu/ManiSkill-Learn">
        Github
      </a>,
      0.41,
      0.348,
      0.696,
      0.864,
      0.388,
      0.316,
      0.216,
      0.2,
      0.252,
    ],
  ];

  const options: MUIDataTableOptions = {
    selectableRowsHideCheckboxes: true,
    responsive: 'standard',
    rowsPerPage: 10,
    filter: 'false',
    expandableRows: false,
  };

  const columns = [
    'Rank',
    'Team Name',
    'Code',
    'Final Score',
    'MoveBucket Train',
    'OpenCabinetDoor Train',
    'OpenCabinetDrawer Train',
    'PushChair Train',
    'MoveBucket Test',
    'OpenCabinetDoor Test',
    'OpenCabinetDrawer Test',
    'PushChair Test',
  ];

  return (
    <DefaultLayout>
      <div className="Results">
        <Typography variant="h3">Challenge Results</Typography>
        <MUIDataTable
          data={data0}
          columns={columns}
          title="No Interaction Track"
          options={options}
        />
        <MUIDataTable
          data={data1}
          columns={columns}
          title="No External Annotation Track"
          options={options}
        />
        <MUIDataTable
          data={data2}
          columns={columns}
          title="No Restriction Track"
          options={options}
        />
      </div>
      <Typography variant="h4" style={{ marginTop: '40px' }} id="awards">
        Awards
      </Typography>
      <div style={{ margin: '10px 0' }}>
        Note: Each team is only awarded on the track with highest ranking. The
        teams who did not open-source their code are not considered for an
        award.
      </div>

      <Typography variant="h5">No Interaction Track</Typography>

      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize (with Special Diversity Award)</TableCell>
          <TableCell>Fattonny</TableCell>
          <TableCell>Midea Group, Beijing Institute of Technology</TableCell>
          <TableCell>
            Kun Wu, Yinuo Zhao, Zhiyuan Xu, Zhen Zhao, Pei Ren, Zhengping Che,
            Chi Harold Liu, Feifei Feng, Jian Tang
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize (with Special Diversity Award)</TableCell>
          <TableCell>bigfish</TableCell>
          <TableCell>
            Beijing University of Posts and Telecommunications, Beijing
            Technology and Business University
          </TableCell>
          <TableCell>Kun Liu, Huiyuan Fu, Zheng Zhang, Huanpu Yin</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>3rd Prize</TableCell>
          <TableCell>ic</TableCell>
          <TableCell>Asteria.com</TableCell>
          <TableCell>Eric Platon, Fabian Dubois, Tom Sonoda</TableCell>
        </TableRow>
      </Table>

      <Typography variant="h5">No External Annotation Track</Typography>

      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize</TableCell>
          <TableCell>EPIC Lab</TableCell>
          <TableCell>Peking University</TableCell>
          <TableCell>Weikang Wan, Hao Shen, He Wang</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize</TableCell>
          <TableCell>MI</TableCell>
          <TableCell>Peking University</TableCell>
          <TableCell>Kangqi Ma, ChenChen Liu, Yadong Mu</TableCell>
        </TableRow>
      </Table>

      <Typography variant="h5">No Restriction Track</Typography>

      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize</TableCell>
          <TableCell>Silver-Bullet-3D</TableCell>
          <TableCell>JD.com</TableCell>
          <TableCell>
            Yingwei Pan, Yehao Li, Yiheng Zhang, Qi Cai, Fuchen Long, Zhaofan
            Qiu, Ting Yao, Tao Mei
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize</TableCell>
          <TableCell>aidan-curtis</TableCell>
          <TableCell>MIT</TableCell>
          <TableCell>Aidan Curtis, Zhutian Yang</TableCell>
        </TableRow>
      </Table>
    </DefaultLayout>
  );
};

export default ManiSkill2021ResultsPage;
